import React, { useContext } from 'react';
import { LaunchDarklyClient } from '@fullstory/launch-darkly';

export const LaunchDarklyClientContext = React.createContext<LaunchDarklyClient | null>(null);

export const useLaunchDarklyClient = () => useContext(LaunchDarklyClientContext);
